import createClient from '../../helpers/api-client';

const storeSuffix = 'FeaturedRequests';

// Actions
export const FETCH_REQUESTS = `fetchRequestsAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_REQUESTS = `beginFetchRequestsMutation${storeSuffix}`;
export const RECEIVED_REQUESTS = `receivedRequestsMutation${storeSuffix}`;
export const REQUESTS_NOT_FOUND = `companiesNotFoundMutation${storeSuffix}`;

// Getters
export const GET_REQUESTS = `getRequestsGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const modelState = () => ({
    featuredRequests: {
        isLoading: true,
        error: false,
        data: [],
    },
});

export const actions = {
    [FETCH_REQUESTS]: ({ state, commit }, closestRegionId) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            let searchParams = {
                take: 8,
            };

            if (closestRegionId) {
                searchParams.regionId = closestRegionId;
            }

            commit(BEGIN_FETCH_REQUESTS);

            try {
                const res = await apiClient.get(`/api/requests`, {
                    params: searchParams,
                });
                commit(RECEIVED_REQUESTS, res);

                resolve(res);
            } catch (error) {
                commit(REQUESTS_NOT_FOUND, {
                    error,
                });
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_FETCH_REQUESTS]: state => {
        state.featuredRequests.isLoading = true;
        state.featuredRequests.error = false;
    },
    [RECEIVED_REQUESTS]: (state, payload) => {
        const { data } = payload;
        state.featuredRequests.isLoading = false;
        state.featuredRequests.error = false;
        state.featuredRequests.data = data.data;
    },
    [REQUESTS_NOT_FOUND]: (state, payload) => {
        state.featuredRequests.isLoading = false;
        state.featuredRequests.error = true;
    },
};

export const getters = {
    [GET_REQUESTS]: state => {
        return state.featuredRequests.data;
    },
    [IS_LOADING]: state => {
        return state.featuredRequests.isLoading;
    },
    [GET_ERROR]: state => {
        return state.featuredRequests.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/featured-requests-model.js